/** Typed client for the plantIdConverse Cloud Function. */
import { postJson } from './_fetch.js';

export interface ConverseCandidate {
  speciesId: string;
  probability: number;
  scientificName: string;
  commonNames: string[];
  family: string | null;
  imageUrl: string | null;
}

export interface ConverseResult {
  speciesId: string;
  scientificName: string;
  commonNames: string[];
  confidence: 'high' | 'medium' | 'low';
  reasoning: string;
}

export interface ConverseResponse {
  sessionId: string;
  assistantMessage: string;
  chips: string[];
  candidates: ConverseCandidate[];
  phase: 'asking' | 'concluded';
  result?: ConverseResult;
}

export interface ConverseInput {
  sessionId?: string;
  userMessage?: string;
  imageBase64?: string;
  imageMimeType?: string;
}

export function converse(input: ConverseInput): Promise<ConverseResponse> {
  return postJson<ConverseInput, ConverseResponse>('/plantIdConverse', input);
}
